document.addEventListener("DOMContentLoaded", function(){
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    var slidingNavToggleLight = document.getElementsByClassName('icon__bolt-light')[0];
    var slidingNavToggleSolid = document.getElementsByClassName('icon__bolt-solid')[0];
    var headerSlidingNav = document.getElementsByClassName('header__sliding-nav')[0];
    var slidingNavToolTip = document.getElementsByClassName('sliding-nav__tooltip')[0];

    if(slidingNavToggleLight){
        
        var date = new Date();
        date.setTime(date.getTime() + (1*24*60*60*1000));

        if (getCookie("sNav_a")) {
            headerSlidingNav.style.display = "block";
            slidingNavToggleLight.style.display = 'none'
            slidingNavToggleSolid.style.display = 'block'
        } 
        if (!getCookie("sNav_a") && !getCookie("sNav_tt") ) {
            setTimeout(function(){
                slidingNavToolTip.style.opacity = 1;
                document.cookie = "sNav_tt" + "=" + (1 || "")  + "; expires=" + date.toUTCString() + "; path=/";
            }, 500);
            setTimeout(function(){
                slidingNavToolTip.style.opacity = 0;
            }, 7000);
        }

        slidingNavToggleLight.addEventListener("click", function(){
            headerSlidingNav.style.display = "block";
            slidingNavToggleLight.style.display = 'none'
            slidingNavToggleSolid.style.display = 'block'

            document.cookie = "sNav_a" + "=" + (1 || "")  + "; expires=" + date.toUTCString() + "; path=/";
        });
        slidingNavToggleSolid.addEventListener("click", function(){
            headerSlidingNav.style.display = "none";
            slidingNavToggleSolid.style.display = 'none'
            slidingNavToggleLight.style.display = 'block'

            document.cookie = "sNav_a" +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        });
    }
  });